import { parseTime } from '@/utils/util'
export const searchForm = {
  line_id: undefined,
  project: undefined,
  staff_style: undefined,
  type: undefined,
  keyword: undefined,
  status: undefined,
  creator: undefined,
  created_at: [],
  id: undefined
}

export const form = {
  line_id: undefined, // 发布平台
  keyword: [
    {
      label: '关键词1',
      value: undefined
    }
  ], // 关键词
}

export const rules = {
  line_id: [{ required: true, message: '请选择发布平台', trigger: 'change' }],
  keyword: [{ required: true, message: '请输入关键词', trigger: 'change' }],
}

export const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 180,
    align: 'center'
  },
  {
    title: '发布平台',
    dataIndex: 'project',
    align: 'left',
    scopedSlots: { customRender: 'project' }
  },
  {
    title: '关键词',
    dataIndex: 'keyword',
    width: 300,
    align: 'left',
  },
  {
    title: '创建人员',
    dataIndex: 'creator',
    align: 'left',
    width: 220,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    width: 220,
    align: 'left',
    scopedSlots: { customRender: 'created_at' }
    // customRender(text) {
    //   text === 0 ? text = '--' : text = parseTime(text)
    //   return text
    // }
  },
  {
    title: '生效',
    dataIndex: 'status',
    align: 'center',
    width: 120,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 160,
    scopedSlots: { customRender: 'operator' }
  }
]
